import { useState } from "react";
import { IoAddOutline } from "react-icons/io5";

import TextboxSearch from "../../../components/common/TextboxSearch";
import TableControls from "../../../components/common/TableControls";
import Modal from "../../../components/common/Modal";
import CorForm from "./CorForm";

const CorHeader = (props) => {
  const { id, account, settings, getDeadline, onFilter, onSearch, onSuccess } =
    props;

  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="block lg:flex justify-between items-center">
      <div>
        <p className="text-gray-500 text-sm">Certificate of Registration</p>
        <span className="text-gray-400 text-xs">
          List of Certificate of Registrations
        </span>
      </div>
      <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
        <TextboxSearch placeholder="Search..." onSearch={onSearch} />
        <TableControls onFilter={() => onFilter(true)} settings={settings} />
        <button
          className="button button-primary mt-2 md:mt-0"
          onClick={() => setShowForm(true)}
        >
          <IoAddOutline className="mr-2" />
          Create COR
        </button>
        <Modal
          size="lg"
          title="Create COR"
          isOpen={showForm}
          isLoading={isLoading}
          onClose={() => setShowForm(false)}
          borderTop
        >
          <CorForm
            id={id}
            account={account}
            isLoading={isLoading}
            setLoading={setIsLoading}
            setShow={setShowForm}
            getDeadline={getDeadline}
            onSuccess={onSuccess}
          />
        </Modal>
      </div>
    </div>
  );
};

export default CorHeader;
